<template>
    <div class="invite-layer">
        <div class="bg-01"></div>
        <div class="bg-02">
            <div class="banner-font animated bounceIn"></div>
        </div>
        <div class="bg-03">
            <div class="user-height">
                <div class="user-info" v-if="isLogin">
                    <p>
                        当前帐号：<span>{{ userName }}</span>
                        <a href="http://passport.ourgame.com/lzgamelogout!webhall.do?nexturl=http://fmz.ourgame.com/activity/invite/index.html" @click="logOut">注销</a>
                    </p>
                </div>
            </div>
            <div class="content">
                <div class="step-part">
                    <ul>
                        <li>
                            <img src="~@/assets/images/draw/step1.png" alt="">
                            <div class="buttons btn1 animate-pictrue"><a href="http://id.ourgame.com/regist.do?third_company=fumozhuan" target="_blank"></a></div>
                        </li>
                        <li>
                            <img src="~@/assets/images/draw/step2.png" alt="">
                            <div class="buttons btn2 animate-pictrue"><a href="http://fmz.ourgame.com/contents/22/26.html" target="_blank"></a></div>
                        </li>
                        <li>
                            <div class="top-pic">
                                <img src="~@/assets/images/draw/step3.png" alt="">
                                <div class="gift-list">
                                    <div class="one-gift" v-for="(item, index) in dataInfo.registlist" :key="index">
                                        <img :src="item.imgUrl" alt="">
                                        <p>{{item.name}}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="getRegistGift === true" class="buttons btn3 gray"><a href="javascript:void(0)"></a></div>
                            <div v-else class="buttons btn3 animate-pictrue" @click="getInviteGift(0)"><a href="javascript:void(0)"></a></div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="com-title yqhyl marg-auto"></div>
        </div>
        <div class="bg-04">
            <div class="con">
                <div class="common-btn invite-number">
                    <p>当前已邀请&nbsp;&nbsp;{{ inviteCount }}&nbsp;&nbsp;位</p>
                </div>
                <div class="invite-btn animate-pictrue" @click="inviteDialog"></div>
            </div>
            <div class="content">
                <ul class="invite-part">
                    <li v-for="(item, index) in dataInfo.invitelist" :key="index">
                        <div class="titles" :class="`title`+(index+1)"></div>
                        <div class="gift-list">
                            <div class="one-gift" v-for="(items, index) in item.list" :key="index">
                                <img :src="items.imgUrl" alt="">
                                <p>{{items.name}}</p>
                            </div>
                        </div>
                        <!-- receive-gray -->
                        <div class="receive animate-pictrue" @click="getInviteGift(item.people)"><a href="javascript:void(0)"></a></div>
                    </li>
                </ul>
                <div class="invite-dis">
                    <h5>邀请好友礼</h5>
                    <p>
                        1、点击“邀请好友”根据页面提示将邀请链接发送给好友，好友通过邀请链接打开页面并且注册成功并创建角色后，
                        即视为成功邀请1人”。 累计邀请2、3、5人可获得相应奖励。<br>
                        2、活动奖励为绑定，奖励将会发放您绑定的服务器角色邮箱。<br>
                        3、用户如果使用任何不正当方式参与此活动，官方有权收回所有非法获得道具，并就相关行为予以处罚。
                    </p>
                </div>
            </div>
        </div>
        <div class="bg-05">
            <div class="con">
                <div class="com-title cjfl marg-auto"></div>
                <lucky-spin @awardsResult="getAwardResult" @bindAccount="goBindAccount" :loginStatus="loginStatus"></lucky-spin>
                <div class="discript">
                    <p>抽奖福利规则说明：</p>
                    <ul>
                        <li>1、首次登录绑定角色后获得1次抽奖机会； </li>
                        <li>3、通过分享链接邀请好友完成注册可获得3次抽奖机会；</li>
                        <li>2、每日登录抽奖页面获得1次抽奖机会；</li>
                        <li>4、单个账号每日限抽奖8次，活动期间玩家抽奖上限为100次。</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="bg-06">
            <div class="content">
                <footer>
                    <p>积极健康的游戏心态是健康游戏的开端，本游戏故事情节设置紧凑，请您合理控制游戏时间，避免沉溺游戏影响生活，注意自我保护，防范网络陷阱。<br>
网络文化经营许可证　京网文[2018]5376-415号 软著登字第1387887号 新广出审【2016】881号<br>
网络游戏出版物号ISBN 978-7-89988-744-8 沪新出科数【2016】301号 网站备案号: <a target="_blank" href="https://beian.miit.gov.cn/">京ICP备09074391号-2</a>
                    </p>
                </footer>
            </div>
        </div>
        <div class="invite-dialog common-dialog">
            <el-dialog
                title="绑定角色"
                :visible.sync="dialogVisible"
                :before-close="handleClose">
                <div class="pop-con">
                    <el-form :model="msgForm" :rules="rules" ref="msgForm" label-width="0" class="msg-ruleForm">
                        <el-form-item label="" prop="gmServer">
                            <el-select v-model="msgForm.gmServer" @change="getRoleBy" placeholder="请选择服务器">
                                <el-option v-for="item in serverList" :key="item.serverid" :label="item.servername" :value="item.serverid"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" prop="roles">
                            <el-select v-model="msgForm.roles" placeholder="请选择角色">
                                <el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName" :value="item.roleName"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="">
                            <div class="c-btn" @click="createRole('msgForm')">确认绑定</div>
                        </el-form-item>
                    </el-form>
                </div>
            </el-dialog>
        </div>
        <!--邀请好友-->
        <div class="invite-dialog common-dialog">
            <el-dialog
                title=""
                :visible.sync="inviteVisible"
                :before-close="handleCloseInvite">
                <div>
                    <img src="~@/assets/images/draw/hhpy.png" alt="">
                    <h4>赢取招募奖励，更得抽奖机会！<br>复制专属邀请链接，发送好友进行注册</h4>
                    <div class="copy-input">
                        <el-input v-model="inviteCode" placeholder="请输入内容"></el-input>
                    </div>
                    <div class="c-btn copy-code-button" :data-clipboard-text="inviteCode" @click="handleCopy">一键复制</div>
                    <p>
                        好友创角成功，赢取惊喜奖励！
                    </p>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import api from '../../api/api'
import getInitData from '../../api/initData.json'
import isLogined from '../../api/isLogined.json'
import getMyLink from '../../api/getMyLink.json'
import luckySpin from '@/components/LuckySpin';
import Clipboard from 'clipboard'
export default {
    data() {
        return {
            // {object} 初始化数据
            dataInfo: {},
            dialogVisible: false,
            recordVisible: false,
            inviteVisible: false,
            // 邀请链接
            inviteCode: '',
            msgForm: {
                gmServer: '',
                roles: ''
            },
            rules: {
                gmServer: [
                    { required: true, message: '请选择服务器', trigger: 'change' }
                ],
                roles: [
                    { required: true, message: '请选择角色', trigger: 'change' }
                ],
            },
            // 角色信息
            roleInfo: {},
            // 角色list
            roleList: [],
            // 服务器list
            serverList: [],
            // 已绑定状态
            isBind: false,
            // 登录状态
            isLogin: false,
            loginStatus: '',
            userName: '',
            userNameBase64:'',
            accId:0,
            // 是否已领取注册礼包
            getRegistGift: false,
            // 当前已邀请人数
            inviteCount: 0,
            // 剩余抽奖次数
            awardsCount: 0,
        }
    },
    components: {
        luckySpin
    },
    mounted() {
        // 获取登录状态
        this.getLoginStatus();
        this.initData();
    },
    methods: {
        initData() {
            let data = {};
            // 此处为模拟数据，请求api后注释掉
            let res = getInitData;
            //api.initData(data).then(res=>{
                if(res.data.result === 1) {
                    this.dataInfo = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
             //}).catch(res=>{})
        },
        /**
         * 获取登录状态
         */
        getLoginStatus() {
            let data = {};
            // 此处为模拟数据，请求api后注释掉
            //let res = isLogined;
            api.isLogined(data).then(res=>{
                if(res.data.result == 0) {
                    // 向子组件传值登录状态
                    this.loginStatus = 'notLogin';
                    // 用户未登录
                    this.isLogin = false;
                } else {
                    // 一登录
                    this.isLogin = true;
                    let getData = res.data.data;
                    // 向子组件传值登录状态
                    this.loginStatus = 'login';
                    this.isBind = getData.isBindRole;
                    this.userName = getData.userName || '';
                    this.userNameBase64 = getData.userNameBase64;
                    this.accId = getData.accId;
                    // 是否已领取注册礼包
                    this.getRegistGift = getData.getRegistGift;

                    console.log(getData);
                    // 当前已邀请人数
                    this.inviteCount = getData.inviteCount;
                    // 剩余抽奖次数
                    this.awardsCount = getData.awardsCount;
                    // 判断是否绑定角色
                    if (getData.isBindRole === false) {
                        this.isBind = false;
                        // 未绑定，弹出绑定角色窗口
                        this.bindRole();
                    }
                }
             }).catch(res=>{})
        },
        /**
         * 获奖结果，更新我的奖品
         */
        getAwardResult(data) {
            console.log(data, '获奖结果');
        },
        goBindAccount(data) {
            this.bindRole();
        },
        /**
         * 根据服务器id获取角色
         */
        getRoleBy(val) {
            this.getRoleData(val);
        },
        /**
         * 领取邀请礼包
         * @param {number} personNumber - 邀请人数
         */
        getInviteGift(personNumber) {
            let data = {
                number: personNumber
            };
            api.getInviteGift(data).then(res=>{
                if(res.status === 200) {
                    if(res.data.result == 1) {
                        this.$message.success('领取成功');
                    } 
                    else if(res.data.result == 0)
                    {
                        $(location).attr('href','http://passport.ourgame.com/passportlogin.do?from=ourgame&nexturl=http://fmz.ourgame.com/activity/invite/index.html');
                    }
                    else if(res.data.result == -2)
                    {
                         this.bindRole();
                    }
                    else {
                        this.$message.error(res.data.message);
                    }
                }
            }).catch(res=>{})
        }, 
        /**
         * 获取服务器list
         */
        getServerList() {
            let data = {};
            api.getServer(data).then(res=>{
                if(res.status === 200) {
                    if(res.data) {
                        this.serverList = res.data[0].areas[0].servers;
                    } else {
                        this.serverList = [];
                    }
                }
            }).catch(res=>{})
        }, 
        /**
         * 获取角色list
         */
        getRoleData(id) {
            let data = {
                serverId: id
            };
            api.getRoleList(data).then(res=>{
                if(res.data.result == 1) {
                    // 获取角色list成功，给roleList赋值
                    this.roleList = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            }).catch(res=>{})
        },
        /**
         * 绑定账号
         */
        bindRole() {
            // 服务器list
            this.getServerList();
            this.dialogVisible = true;
        },
        /**
         * 绑定角色
         */
        createRole(formName) {
            console.log("bind rold start")
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let data = {
                        roleName: this.msgForm.roles,
                        serverId: this.msgForm.gmServer
                    };
                    api.bindRole(data).then(res=>{
                        if(res.data.result == 1) {
                            // 关闭弹窗
                            this.isBind = true;
                            this.getLoginStatus();

                            this.dialogVisible = false;
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }).catch(res=>{})
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        /**
         * 关闭绑定角色
         */
        handleClose() {
            this.dialogVisible = false;
        },
        /**
         * 获取注册礼包
         */
        handleGet() {
            let data = {};
            api.getRegGift(data).then(res=>{
                if(res.status === 200) {
                    if(res.data.result === 1) {
                        this.$message({
                            message: "领取成功",
                            type: 'success'
                        });
                    } else {
                        this.$message.error(res.data.message);
                    }
                }
            }).catch(res=>{})
        },
        /**
         * 关闭邀请弹窗
         */
        handleCloseInvite() {
            this.inviteVisible = false;
        },
        /**
         * 复制按钮事件
         */
        handleCopy() {
            var clipboard = new Clipboard('.copy-code-button') // 这里可以理解为选择器，选择上面的复制按钮
            clipboard.on('success', e => {
                this.$message.success('复制成功');
                // 释放内存
                clipboard.destroy();
                this.handleCloseInvite();
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.error('复制失败');
                // 释放内存
                clipboard.destroy();
            })
        },
        /**
         * 邀请好友弹窗
         */
        inviteDialog() {
            if (!this.isLogin) {
                //this.$message.error('请登录');
                $(location).attr('href','http://passport.ourgame.com/passportlogin.do?from=ourgame&nexturl=http://fmz.ourgame.com/activity/invite/index.html');
            } else {
                if (this.isBind) {
                    this.inviteVisible = true;
                    // 获取专属链接
                    this.getLink();
                } else {
                    // 未绑定，弹出绑定角色窗口
                    this.bindRole();
                }
            }
        },
        /**
         * 获取专属链接
         */
        getLink() {
            let data = {};
            // 此处为模拟数据，请求api后注释掉
            let res = getMyLink;
            // api.getMyLinks(data).then(res=>{
                if(res.data.result === 1) {
                    this.inviteCode = 'http://id.ourgame.com/regist.do?third_company=fumozhuan~'+this.accId;
                } else {
                    this.$message.error(res.data.message);
                }
            // }).catch(res=>{})
        },
        
        /**
         * 注销
         */
        logOut() {
            let data = {};
            api.loginOut(data).then(res=>{
                if(res.data.Result == 0) {
                    // 更新用户状态
                    this.getLoginStatus();
                }
            }).catch(res=>{})
        },
    }
}
</script>
<style lang="scss">
.pop-img img{
    width: 200px;
    height: auto;
}
.el-tooltip__popper{
    padding: 6;
}
.el-tooltip__popper.is-dark{
    background: $color-blue2 !important;
}
.popper__arrow{
    border-bottom-color: #54b9dd !important;
}
.popper__arrow::after{
    border-bottom-color: $color-blue2 !important;
}
.invite-layer{
    .common-dialog {
        .el-dialog__header{
            padding: 60px 0 0 0;
            margin: 0 100px;
            line-height: 50px;
            text-align: center;
            span{
                font-size: 20px;
                color: $color-yellow1;
            }
        }
        .el-dialog__headerbtn{
            right: -53px;
            top: 0;
            width: 52px;
            height: 52px;
            background-color: $color-yellow2;
            font-size: 30px;
            color: $black1;
        }
    }
    .invite-dialog {
        .el-dialog {
            background:url(../../assets/images/draw/pop-bg.jpg) center top no-repeat;
            width: 737px;
            height: 504px;
            background-size: cover;
            box-shadow: none;
        }
        .el-dialog__body{
            padding: 40px 100px;
            text-align: center;
            color: $color-yellow3;
        }
        .copy-input {
            margin: 30px auto;
        }
        .el-select {
            width: 100%;
        }
        h4 {
            font-size: 18px;
            line-height: 36px;
            font-weight: 500;
        }
        .c-btn {
            margin: 20px auto 0 auto;
            @include sprite-icon();
            background-position: -425px -414px;
            width: 260px;
            height: 82px;
            line-height: 82px;
            font-size: 24px;
            color: #7b5b04;
            cursor: pointer;
        }
        p {
            line-height: 50px;
            font-size: 14px;
        }
    }
    .record-dialog {
        .el-dialog {
            background:url(../../assets/images/barrage/pop-bg1.jpg) center top no-repeat;
            width: 888px;
            height: 439px;
            background-size: cover;
            box-shadow: none;
        }
        .el-dialog__header{
            border-bottom: 3px solid $color-white;
        }
        .el-dialog__body{
            padding: 40px 100px;

            ul{
                height: 160px;
                @include flex-start();
                @include flex-wrap-wrap();
                li{
                    margin: 2px;
                    width: 80px;
                    height: 80px;
                    text-align: center;

                    img{
                        margin: 0 auto;
                        width: 46px;
                        height: 46px;
                    }
                    p{
                        width: 80px;
                        line-height: 20px;
                        font-size: 12px;
                        text-align: center;
                        color: $color-white;
                        @include text-ellipsis();
                    }
                }
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.invite-layer{
    padding: 0;
    .com-title {
        width: 549px;
        height: 99px;
    }
    .yqhyl {
        margin-top: 47px;
        background:url(../../assets/images/draw/yqhyl.png) center top no-repeat;
    }
    .cjfl {
        background:url(../../assets/images/draw/cjfl.png) center top no-repeat;
    }
    .bg-01{
        background:url(../../assets/images/draw/bg-01.jpg) center top no-repeat;
        height: 281px;
    }
    .con{
        margin: 0 auto;
        width: 900px;
    }
    .bg-02{
        position: relative;
        background:url(../../assets/images/draw/bg-02.jpg) center top no-repeat;
        height: 645px;
        .banner-font {
            margin: 0 auto;
            background:url(../../assets/images/draw/banner-font.png) center top no-repeat;
            width: 917px;
            height: 239px;
        }
    }
    .bg-03{
        background:url(../../assets/images/draw/bg-03.jpg) center top no-repeat;
        height: 566px;

        .user-height {
            height: 110px;
        }
        .user-info {
            background:url(../../assets/images/draw/logined-bg.png) center bottom repeat-x;
            height: 90px;
            line-height: 90px;

            p {
                text-align: center;
                font-size: 22px;

                span {
                    margin: 0 20px;
                    color: $color-red2;
                }
                a {
                    color: $color-blue3;
                }
            }
        }
        .step-part {
            ul {
                padding: 0 10px;
                @include flex-space-between();
                li {
                    @include flex-center();
                    position: relative;
                    width: 389px;
                    height: 250px;
                    background:url(../../assets/images/draw/bg2.png) center top no-repeat;
                    padding-top: 64px;

                    .top-pic {
                        width: 326px;
                        height: 249px;
                    }

                    .buttons {
                        position: absolute;
                        z-index: 9;
                        margin: 145px auto 0 0;
                        @include sprite-icon();

                        a {
                            width: 144px;
                            height: 37px;
                            display: block;
                        }
                    }
                    .btn1 {
                        background-position: 0 -326px;
                    }
                    .btn2 {
                        background-position: -153px -326px;
                    }
                    .btn3 {
                        background-position: -308px  -326px;
                    }

                    .gift-list {
                        padding-top: 20px;
                        @include flex-space-between();

                        .one-gift {
                            width: 76px;
                            height: 80px;
                            text-align: center;

                            img{
                                margin: 0 auto;
                                width: 46px;
                                height: 46px;
                            }
                            p{
                                width: 80px;
                                line-height: 20px;
                                font-size: 12px;
                                text-align: center;
                                color: $color-blue4;
                                @include text-ellipsis();
                            }
                        }
                    }
                }
            }
        }
    }
    .bg-04{
        background:url(../../assets/images/draw/bg-04.jpg) center top no-repeat;
        height: 1007px;
        .con {
            padding-top: 6px;
            .invite-number {
                margin: 0 auto 50px auto;
            }
        }
        .invite-part {
            padding: 80px 20px 20px;
            @include flex-space-between();
            li {
                width: 368px;
                background:url(../../assets/images/draw/bg1.png) center top no-repeat;
                padding-top: 64px;

                .receive {
                    margin: 40px auto;
                    width: 218px;
                    height: 62px;
                    @include sprite-icon();
                    background-position: -466px -311px;

                    a {
                        width: 218px;
                        height: 62px;
                        display: block;
                    }
                }
                .receive-gray {
                    @include sprite-icon();
                    background-position: -692px -311px;
                }
                
                .titles {
                    width: 200px;
                    height: 40px;
                    margin: 0 auto;
                    @include sprite-icon();
                }
                .title1 {
                    background-position: 30px -534px;
                }
                .title2 {
                    background-position: 30px -595px;
                }
                .title3 {
                    background-position: 30px -655px;
                }
                .gift-list {
                    width: 200px;
                    margin: 10px auto;
                    @include flex-start();
                    @include flex-wrap-wrap();
                    height: 200px;
                    .one-gift:nth-child(1) {
                        width: 100%;
                        margin: 0 auto;
                    }
                    .one-gift {
                        width: 50%;
                        text-align: center;

                        img{
                            margin: 0 auto;
                            width: 53px;
                        }
                        p{
                            line-height: 20px;
                            font-size: 14px;
                            text-align: center;
                            color: $color-blue4;
                            @include text-ellipsis();
                        }
                    }
                }
            }
        }
        .invite-dis {
            h5 {
                width: 100%;
                text-align: center;
                font-size: 20px;
                line-height: 50px;
                font-weight: 500;
            }
            p {
                font-size: 16px;
                line-height: 28px;
            }
        }
    }
    .bg-05{
        background:url(../../assets/images/draw/bg-05.jpg) center top no-repeat;
        height: 1036px;

        .con {
            .discript {
                margin: 50px auto 0 auto;
                width: 800px;
                background-color: #4a4751;
                p {
                    width: 100%;
                    font-size: 18px;
                    line-height: 50px;
                    text-align: center;
                }
                ul {
                    padding: 0 20px 20px 20px;
                    @include flex-start();
                    @include flex-wrap-wrap();
                    li {
                        width: 60%;
                        font-size: 14px;
                        line-height: 30px;
                    }
                    li:nth-child(1),li:nth-child(3) {
                        width: 40%;
                    }
                }
            }
        }
    }
    .bg-06{
        background:url(../../assets/images/draw/bg-06.jpg) center top no-repeat;
        height: 223px;
        footer{
            padding: 60px 100px;
            p{
                font-size: 14px;
                color: $color-white;
                text-align: center;
                line-height: 28px;
            }
            a{
                color: $color-yellow;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/special/InviteFriends.vue